import axios from '@/utils/axios'

let standardPromise = null
let dimensionalPromise = null

export function getStandardUnits() {
  if (!standardPromise) {
    standardPromise = axios
      .get('/units?type=standard')
      .then(res => res.data.data)
      .catch(err => {
        standardPromise = null  
        throw err
      })
  }
  return standardPromise
}

export function getDimensionalUnits() {
  if (!dimensionalPromise) {
    dimensionalPromise = axios
      .get('/units?type=dimensional')
      .then(res => res.data.data)
      .catch(err => {
        dimensionalPromise = null
        throw err
      })
  }
  return dimensionalPromise
}

// Settings mein units update hon to call karo
export function clearUnitsCache() {
  standardPromise = null
  dimensionalPromise = null
}